import React from "react";
import { IconType } from "react-icons";

interface IconProps extends React.SVGAttributes<SVGElement> {
  icon: IconType;
}

/**
 * react-icons' IconType return type (ReactNode) isn't directly assignable as a
 * JSX component under React 19's stricter types — this wrapper isolates the cast.
 */
export function Icon({ icon, ...props }: IconProps) {
  const Component = icon as unknown as React.FC<React.SVGAttributes<SVGElement>>;
  return <Component {...props} />;
}
